<template>
  <div class="bacgk" style="margin-top: 15px" v-if="status == 'UN_OFFERD' && !isSelf">
      <p class="tilteMesg">参与报价</p>
<!--      <span>（完善以下信息参与投标）当前佣金比例为 </span>
      <span style="color: red">0%</span>-->
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      style="padding: 15px"
    >
<!--      <el-form-item v-if="secondBidding == 1" label="服务报价" prop="offerPriceSecond">
        <el-input
          @input="inputChange"
          placeholder="请输入服务报价"
          v-model="ruleForm.offerPriceSecond"
          :style="{ width: inputWidth }"
        >
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item v-else label="服务报价" prop="offerPrice">
        <el-input
          @input="inputChange"
          placeholder="请输入服务报价"
          v-model="ruleForm.offerPrice"
          :style="{ width: inputWidth }"
        >
          <template slot="append">元</template>
        </el-input>
      </el-form-item>-->
      <el-form-item label="服务报价" prop="offerPrice">
        <el-input
            :disabled="isOffered == 1"
          @input="inputChange"
          placeholder="请输入服务报价"
          v-model="ruleForm.offerPrice"
          :style="{ width: inputWidth }"
        >
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="开工日期" prop="startTime">
        <el-date-picker
            :disabled="isOffered == 1"
          :style="{ width: inputWidth }"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
          v-model="ruleForm.startTime"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="完工日期" prop="endTime">
        <el-date-picker
            :disabled="isOffered == 1"
          :style="{ width: inputWidth }"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
          v-model="ruleForm.endTime"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="报价详情" prop="offerClaim">
        <el-input
            :disabled="isOffered == 1"
          v-model="ruleForm.offerClaim"
          type="textarea"
          placeholder="请填写报价详情"
          :rows="6"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="isOffered == 0" label="报价附件" prop="url">
        <el-upload
            class="avatar-uploader"
            action="/service-center/upload/file/single"
            :file-list="fileList"
            :on-error="handleFileError"
            :on-change="handleChange"
            :on-success="handleFileSuccess">
          <el-button size="small" type="primary">上传文档</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item v-else label="报价附件" prop="url">
        <span style="color: #1890FF;cursor: pointer;"
              @click="downloadFile(ruleForm.url, ruleForm.fileName)">{{ ruleForm.fileName }}</span>
      </el-form-item>

      <el-form-item v-if="isOffered == 1">
        <el-button type="warning" disabled
          >已报价</el-button
        >
      </el-form-item>
      <el-form-item v-else>
        <el-button type="primary"  @click="submitForm('ruleForm')"
          >立即报价</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  getActivityDetailInfo,
  getNewcurrent,
  getProviderIdentity,
  offerPage,
  reportOffer
} from "../../../../utils/interface";

export default {
  data() {
    return {
      fileList:[],
      secondBidding:0,
      isOffered:0,
      status:'',
      isSelf: false,
      inputWidth: "400px",
      ruleForm: {
        demandId:"",
        offerPrice: "",
        // offerPriceSecond: "",
        startTime: "",
        endTime: "",
        offerClaim: "",
      },
      rules: {
        offerPrice: [{ required: true, message: "请输入服务报价", trigger: "blur" }],
        // offerPriceSecond: [{ required: true, message: "请输入服务报价", trigger: "blur" }],
        startTime: [
          {
            type: "string",
            required: true,
            message: "请选择开工日期",
            trigger: "change",
          },
        ],
        endTime: [
          {
            type: "string",
            required: true,
            message: "请选择完工日期",
            trigger: "change",
          },
        ],
        offerClaim: [{ required: true, message: "请填写报价详情", trigger: "blur" }],
      },
    };
  },
  methods: {
    init(isSelf, uuid, secondBidding, status) {
      this.isSelf = isSelf;
      this.secondBidding = secondBidding;
      this.ruleForm.demandId = uuid;
      this.status = status;
      offerPage({demandId:uuid}).then(resp=>{
        if(null !== resp && resp.data.length > 0){
          if(resp.data[0].secondBidding == 1 && resp.data[0].offerPriceSecond){
            resp.data[0].offerPrice = resp.data[0].offerPriceSecond;
          }else{
            resp.data[0].offerPrice = resp.data[0].offerPrice;
          }
          this.ruleForm = resp.data[0];
          this.isOffered = 1;
        }
      });
    },
    // 模板附件
    handleFileSuccess(res, file) {
      // this.fileList.push(res);
      this.$set(this.ruleForm, 'url', res.url);
      this.$set(this.ruleForm, 'fileName', res.name);
      this.$refs.ruleForm.validateField('url');
    },

    handleChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]
      }
    },

    handleFileError(err, file, fileList) {
      this.$message.error(err);
    },
    submitForm(formName) {
      if(this.$store.state.isLogin) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            getProviderIdentity()
                .then((res) => {
                  if(res && res.data == 1){
                    reportOffer(this.ruleForm).then((res) => {
                      if (res.success) {
                        this.$message({
                          type: "success",
                          message: "操作成功",
                          duration:1200,　　//显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
                          onClose:()=>{
                            //跳转页面或执行方法
                            this.$router.go(0);
                          }
                        });
                      } else {
                        this.$message({
                          type: "error",
                          message: res.message,
                        });
                      }
                    });
                  }else{
                    this.$message({
                      type: "error",
                      message: "非服务商不允许参加报价！",
                      duration:1200,　　//显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
                    });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });

          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }else{
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    inputChange() {
      this.ruleForm.offerPrice = this.ruleForm.offerPrice.replace(/[^0-9.]/g, "");
    },
    downloadFile(url,name) {
      fetch(url).then((res) => {
        res.blob().then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = name;
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/index.less";
/deep/.el-form-item__label {
  font-weight: bold !important;
  color: #333 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/details/demandDetailsOffer.vue